// src/prints/DelVehPrint.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import Logo from "../assets/infraLogo.jpg"; // fallback logo
import { useParams, useNavigate } from "react-router-dom";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const DelVehPrint = () => {
  useAuthRedirect();
  const { delNo } = useParams();

  const [headerDetails, setHeaderDetails] = useState({});
  const [itemDetails, setItemDetails] = useState([]);
  const navigate = useNavigate();

  // ---------- Site / Company info (logo, name, address, phone, email) ----------
  const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};

        // ensure absolute URL if a relative path ever comes back
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }

        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);

  // ---------- Delivery note details ----------
  useEffect(() => {
    const fetchDetails = async () => {
      if (!delNo) {
        console.log("No Delivery Note Number (delNo) provided");
        return;
      }
      try {
        const response = await axios.get(
          `${API_BASE}/deliveryNote_detail?delNo=${delNo}`
        );

        if (response.data && response.data.deliveryDetail?.length > 0) {
          const items = response.data.deliveryDetail;

          const header = {
            del_no: items[0].del_no || "N/A",
            del_id: items[0].del_id || "N/A",
            frombranch: items[0].frombranch || "N/A",
            tobranch: items[0].tobranch || "N/A",
            del_send: items[0].del_send || "N/A",
            del_date: items[0].del_date || "N/A",
          };

          setHeaderDetails(header);
          setItemDetails(items);
        } else {
          console.warn("API Response does not contain expected data structure");
        }
      } catch (error) {
        console.error("Error fetching delivery details:", error);
      }
    };

    fetchDetails();
  }, [delNo]);

  const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;

  return (
    <div className="prPrint-container">
      {/* Header (from /api/siteinfo with fallback) */}
      <div className="prPrint-header">
        <img src={logoSrc} alt={`${site.name} Logo`} className="prPrint-logo" />
        <div className="prPrint-company-details">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          {site.address && <p>{site.address}</p>}
          {(site.phone || site.email) && (
            <p>
              {site.phone && <span>Ph: {site.phone}</span>}
              {site.phone && site.email && <span> | </span>}
              {site.email && <span>Email: {site.email}</span>}
            </p>
          )}
        </div>
      </div>

      {/* Delivery meta */}
      <table className="prPrint-info-table">
        <tbody>
          <tr>
            <td>
              <strong>Number:</strong> {delNo}
            </td>
            <td>
              <strong>Date:</strong>{" "}
              {headerDetails.del_date
                ? new Date(headerDetails.del_date).toLocaleDateString("en-GB")
                : "N/A"}
            </td>
          </tr>
          <tr>
            <td>
              <strong>From Branch:</strong> {headerDetails?.frombranch || "N/A"}
            </td>
            <td>
              <strong>To Branch:</strong> {headerDetails?.tobranch || "N/A"}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Send Through :</strong> {headerDetails?.del_send || "N/A"}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Items */}
      <table className="prPrint-item-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Descriptions</th>
            <th>Specification/Part No</th>
            <th>UOM</th>
            <th>Del.Qty</th>
            <th>Rec.Qty</th>
            <th>Bal.Qty</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {itemDetails.length > 0 ? (
            itemDetails.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.del_description || "N/A"}</td>
                <td>{item.del_specification || "N/A"}</td>
                <td>{item.del_UM || "N/A"}</td>
                <td>{item.Del_Qty || 0}</td>
                <td>{item.Rec_Qty || 0}</td>
                <td>{item.Bal_Qty || 0}</td>
                <td>{item.del_remarks || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No items found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <button className="prPrint-button" onClick={() => window.print()}>
        Print
      </button>
    </div>
  );
};

export default DelVehPrint;
